/*
 * @Author: calendar-config
 * @Date: 2021-02-07 15:38:28
 * @LastEditTime: 2021-02-22 17:02:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \04eos-app\src\pages\testDrive\day\calendarConfig.js
 */
export const Theme = {}
export const StateColors = {
  'SCHEDULED': '#B4B4B4',
  'CONFIRMED': '#B4B4B4',
  'COMPLETED': '#2FC25B',
  'CANCELLED': '#FFA20A',
  'OVERDUE': '#FE2B66'
}